"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
var theme_1 = require("../../components/theme");
var theme_palette_1 = require("../../components/theme.palette");
exports.CSS = {
    container: 'c-TagList__selected',
    title: 'c-TagList__selected_title',
    text: 'c-TagList__selected_text',
    tools: 'c-TagList__selected_tools',
    spanomatic: 'c-Span-O-Matic'
};
exports.Style = (_a = {},
    _a[exports.CSS.container] = {
        paddingLeft: theme_1.DefaultTheme.space(2),
        paddingRight: theme_1.DefaultTheme.space(2),
        fontSize: '120%',
        backgroundColor: (0, theme_1.rgba)(theme_palette_1.ColorPaletteOrange.C100),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: theme_1.DefaultTheme.space(10),
        minHeight: theme_1.DefaultTheme.space(10)
    },
    _a[exports.CSS.title] = {
        flex: 1,
        overflow: 'hidden',
        'text-overflow': 'ellipsis',
        'white-space': 'nowrap'
    },
    _a[exports.CSS.text] = {
        flex: 1,
        overflow: 'hidden',
        'text-overflow': 'ellipsis',
        'white-space': 'nowrap',
        padding: "0 ".concat(theme_1.DefaultTheme.space(1))
    },
    _a[exports.CSS.tools] = {
        display: 'flex'
    },
    _a[exports.CSS.spanomatic] = {
        color: "rgb(".concat(theme_palette_1.ColorPaletteRed.A700, ")")
    },
    _a);
//# sourceMappingURL=collection.toolbar.style.js.map